import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { ConfirmEventType, ConfirmationService, MenuItem, Message } from 'primeng/api';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextEditorQuestion } from 'src/app/misc/component/dynamic-form/question-editor';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalConstants, ImageTypes } from 'src/app/services/global-constants';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CryptoService } from 'src/app/services/crypto.service';


@Component({
  selector: 'app-question-bank-list',
  templateUrl: './question-bank-list.component.html',
  styleUrl: './question-bank-list.component.scss'
})

export class QuestionBankListComponent {
  selectedTopic: any;
  expandedTopic: boolean = false;
  skelition = true;

  //Constants
  @Output() updateDataEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
  @ViewChild('printButton') printButton?: ElementRef;

  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()
  @Input() tags: any[] = [];
  menuItems: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.actionCall({ id: this.operationType._id, action: 'Update' })
      }
    },
    {
      label: '<span class="mx-3">حذف</span>',
      escape: false,
      icon: 'pi pi-fw pi-trash',
      command: () => {
        this.actionCall({ id: this.operationType._id, action: 'Delete' })
      }
    }
  ];


  GlobalConstants = GlobalConstants;

  questions: QuestionBase<string>[] = [];
  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;
  operationType: any;
  openCreateModal: boolean = false;

  allowedTags: string[] = this.permissionService.extractTags('ASSESSMENT_TAGS', 'r')
  @Input() currentQBank: any;
  @Input() questionBankTopics: any[] = [];
  @Input() questionBankService: any[] = [];
  @Input() activeTabIndex: number = 0;
  @Input() currentQBankId: string = "";
  @Input() topics: any;
  @Input() ministries: any;
  QBTab: string = 'Service';
  locationOrigin: string = location.origin;
  queryParams: any = {};
  standardQBID: string = '65f71c25cf3086b3277d7f2d';
  staticFileUrl = GlobalConstants.staticFilesURL;
  dropTopic: any
  filteredQBTopics: any;
  dropMinistry: any
  filteredQBService: any;
  subTotalService: number = 0;
  subTotalTopic: number = 0;
  dropType: any
  types: any = [
    { id: 1, label: this.translate('Standard Question Bank') },
    { id: 2, label: this.translate('Dedicated Question Bank') }
  ];
  printQuestionCount: number = 0;

  //toogling variables
  showPrintModal: boolean = false;
  printableData: any[] = []
  loadingPrint: boolean = false;
  selectedPrintableTopics: any[] = [];
  selectionPrint: boolean = false;
  showSelectTopicsModal: boolean = false;
  showPrintData: boolean = false;
  selectAllTopics: boolean = false;
  searchText: string = "";
  topicView: string = 'non_sample_topic';

  //Forms
  printCriteriaForm: FormGroup = this.fb.group({
    title: ['', Validators.required],
    criteriaArray: this.fb.array([])
  });


  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private cryptoService: CryptoService
  ) { }

  ngOnInit() {
    this.activatedRouter.queryParams.subscribe(params => {
      if (params['QBankId']) {
        this.currentQBankId = params['QBankId'];
      }
      if (params['tabIndex']) {
        const savedTabIndex = +params['tabIndex'];
        if (!isNaN(savedTabIndex)) {
          this.activeTabIndex = savedTabIndex;
        }
      }
      if (params['QBTab']) {
        this.QBTab = params['QBTab'];
      }
      if (params['topicView']) {
        this.topicView = params['topicView'];
      }
      this.queryParams = { 'QBankId': this.currentQBankId, 'tabIndex': this.activeTabIndex };

      this.filteredQBTopics = this.questionBankTopics;
      this.filteredQBService = this.questionBankService.filter(e => this.topicView === 'non_sample_topic' ? e.questionType == 'Original' : e.questionType == 'Sample');
      this.makequestion();
    })

    this.addPrintCriteria()
  }

  getHostname(): string {
    return window.location.protocol + '//' + window.location.host;
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  random(min: number, max: number) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  get ministriesCriteria() {
    return (this.printCriteriaForm.get('criteriaArray') as FormArray);
  }

  async printQuestions() {
    let { criteriaArray, title } = this.printCriteriaForm.getRawValue();
    this.loadingPrint = true;
    let res = await this.dataService.postData('question-bank/printable', { tags: this.allowedTags, ministriesWithCount: criteriaArray, save: !this.selectionPrint, title })
    if (!res.error) {
      this.printableData = res.data;
      if (!this.selectionPrint) {
        this.printQuestionCount = this.printableData.map(e => e.data.length).reduce((p: number, c: number) => p + c);
        this.goToPrint({ data: this.printableData, count: this.printQuestionCount });
      } else {
        this.printableData = this.printableData.flatMap(d => d.data)
        this.showSelectTopicsModal = true;
        this.loadingPrint = false;
      }
    } else {
      this.loadingPrint = false;
    }
  }

  goToPrint(payload: any) {
    let encryptedQuery = this.cryptoService.encodeObject(payload);
    localStorage.setItem('print-query', encryptedQuery);
    this.router.navigate(['/questions/pdf-builder'])
  }

  selectAllPrintable() {
    if (this.selectAllTopics) {
      this.selectedPrintableTopics = this.printableData
    } else {
      this.selectedPrintableTopics = []
    }
  }


  async structureSelectedPrintableDataAndPrint() {
    this.showSelectTopicsModal = false;
    const groupedData = Object.values(this.selectedPrintableTopics.reduce((acc, obj) => {
      const key = obj.ministry._id;
      if (!acc[key]) {
        acc[key] = { ministry: obj.ministry, data: [] };
      }
      acc[key].data.push(obj);
      return acc;
    }, {}));

    this.printableData = groupedData;

    await this.dataService.postData('question-bank/assessment/pdfs', { payload: this.printableData, title: this.printCriteriaForm.get('title')?.getRawValue() });

    this.printQuestionCount = this.printableData.map(e => e.data.length).reduce((p: number, c: number) => p + c);
    this.goToPrint({ data: this.printableData, count: this.printQuestionCount });
  }

  addPrintCriteria() {
    this.ministriesCriteria.push(this.fb.group({
      ministryId: ['', Validators.required],
      count: [null, Validators.required]
    }));
  }

  clickNgxPrintButton() {
    this.showPrintData = true;
    setTimeout(() => {
      const button = this.printButton?.nativeElement as HTMLButtonElement;

      this.renderer.setStyle(button, 'display', 'block');

      button.click();

      this.renderer.setStyle(button, "display", "none")
      this.resetPrintableState()
    }, 1000)
  }



  resetPrintableState() {
    this.resetForm()
    this.showPrintModal = false;
    this.loadingPrint = false;
    this.printableData = [];
    this.selectionPrint = false;
    this.showSelectTopicsModal = false;
    this.selectedPrintableTopics = [];
    this.showPrintData = false;
  }

  resetForm() {
    // Reset the form controls
    this.printCriteriaForm.reset();

    // Clear the FormArray
    const ministriesArray = this.ministriesCriteria;
    while (this.ministriesCriteria.length > 1) {
      ministriesArray.removeAt(ministriesArray.length - 1);
    }
  }


  removePrintCriteria(index: number) {
    this.ministriesCriteria.length > 1 && this.ministriesCriteria.removeAt(index);
  }

  displayError(errorName: string, control?: AbstractControl | null): boolean {
    return (control && control.hasError(errorName) && control.touched) ?? false;
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange['tags']) {
      this.makequestion();
    }
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag)
  }

  openTopicDialog(topic: any) {
    this.selectedTopic = topic;
    this.expandedTopic = true;
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  openTypeMenu(menu: any, event: any, type: any) {
    this.operationType = type;
    menu.toggle(event);
  }

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('Question'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new TextEditorQuestion({
        key: 'description',
        label: this.translate('Answer'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      })
    ];

    if (this.QBTab === 'Topic') {
      this.questions.push(new DropdownQuestion({
        key: 'topic',
        label: this.translate('Topic'),
        required: true,
        options: this.topics.map((e: { name: any; _id: any; }) => ({ label: e.name, value: e._id })),
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }));
    }
  }

  launchUrl(url: string) {
    window.open(this.locationOrigin + '/data/' + url, '_blank');
  }

  ChangeQBTab(tab: string, event: any) {
    this.resetFilters();
    this.QBTab = tab;
    this.activeTabIndex = event.index;
    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: { QBTab: this.QBTab },
      queryParamsHandling: 'merge'
    });
  }

  changeTopicView(tab: string, event: any) {
    this.resetFilters();
    this.topicView = tab;
    this.activeTabIndex = event.index;
    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: { topicView: this.topicView },
      queryParamsHandling: 'merge'
    });
  }

  getSubTotalService(data: any) {
    this.subTotalService = 0;
    data.forEach((item: any) => {
      if (item.questions) {
        this.subTotalService += item.questions.length;
      }
    });

    return this.subTotalService;
  }

  getSubTotalTopic(data: any) {
    this.subTotalTopic = 0;
    data.forEach((item: any) => {
      if (item.questions) {
        this.subTotalTopic += item.questions.length;
      }
    });

    return this.subTotalTopic;
  }

  onChangeDropdown() {

    if (this.dropTopic) {
      this.filteredQBTopics = this.questionBankTopics.filter((topics: { topic: any; }) => topics.topic === this.dropTopic._id);
      this.filterQuestionBanks(2)
    }

    if (this.dropMinistry) {
      this.filteredQBService = this.questionBankService.filter((item: { data: { ministry: { _id: any; }; }[]; }) => {
        return item.data && item.data[0] && item.data[0].ministry && item.data[0].ministry._id === this.dropMinistry._id;
      });
      this.filterQuestionBanks(1)
    }

    if (this.dropType) {
      if (this.dropType.id == 1) {
        if (this.dropMinistry) {
          this.filteredQBService = this.filteredQBService.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
          this.filterQuestionBanks(1)
        }
        else {
          this.filteredQBService = this.questionBankService.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
        }
        if (this.dropTopic) {
          this.filteredQBTopics = this.filteredQBTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
          this.filterQuestionBanks(2)
        }
        else {
          this.filteredQBTopics = this.questionBankTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
        }
      }
      else {
        if (this.dropTopic) {
          this.filteredQBTopics = this.filteredQBTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
          this.filterQuestionBanks(1)
        }
        else {
          this.filteredQBTopics = this.questionBankTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
        }
        if (this.dropMinistry) {
          this.filteredQBService = this.filteredQBService.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
          this.filterQuestionBanks(2)
        }
        else {
          this.filteredQBService = this.questionBankService.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
        }
      }
    }
  }

  resetFilters() {
    this.dropMinistry = null;
    this.dropTopic = null;
    this.dropType = null;
    this.searchText = "";
    this.filteredQBTopics = this.questionBankTopics;
    this.filteredQBService = this.questionBankService;
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      data.questionBankId = this.currentQBank._id;
      data.type = this.QBTab;
      data.questionType = this.topicView === 'non_sample_topic' ? 'Original' : 'Sample'
      let res = await this.dataService.postData('topic', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error') },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.DynamicFormComponent.resetForm();
      this.updateDataEvent.emit({});
      this.openCreateModal = false;
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      data.questionBankId = this.currentQBank._id;
      let res = await this.dataService.postData(
        `topic`,
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      this.updateDataEvent.emit({});
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    console.log($event);
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.operationType;
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: this.translate('Question'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-md-12 col-sm-12 col-12',
          }),

          new TextEditorQuestion({
            key: 'description',
            label: this.translate('Answer'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.description,
            className: 'col-md-12 col-sm-12 col-12',
          })
        ];

        if (this.QBTab === 'Topic') {
          this.updateQuestions.push(new DropdownQuestion({
            key: 'topic',
            label: this.translate('Topic'),
            required: true,
            options: this.topics.map((e: { name: any; _id: any; }) => ({ label: e.name, value: e._id })),
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.topic,
            className: 'col-md-12 col-sm-12 col-12',
          }));
        }
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`topic/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateDataEvent.emit({});
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  filterQuestionBanks(type: number) {
    const trimmedSearchText = this.searchText?.trim().toLowerCase();
    if (!trimmedSearchText) {
      if (type === 1) {
        this.filteredQBService = this.questionBankService;
      }
      else {
        this.filteredQBTopics = this.questionBankTopics;
      }

      if (this.dropTopic) {
        this.filteredQBTopics = this.questionBankTopics.filter((topics: { topic: any; }) => topics.topic === this.dropTopic._id);
      }

      if (this.dropMinistry) {
        this.filteredQBService = this.questionBankService.filter((item: { data: { ministry: { _id: any; }; }[]; }) => {
          return item.data && item.data[0] && item.data[0].ministry && item.data[0].ministry._id === this.dropMinistry._id;
        });
      }

      if (this.dropType) {
        if (this.dropType.id == 1) {
          if (this.dropMinistry) {
            this.filteredQBService = this.filteredQBService.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
          }
          else {
            this.filteredQBService = this.questionBankService.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
          }
          if (this.dropTopic) {
            this.filteredQBTopics = this.filteredQBTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
          }
          else {
            this.filteredQBTopics = this.questionBankTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId == this.standardQBID);
          }
        }
        else {
          if (this.dropTopic) {
            this.filteredQBTopics = this.filteredQBTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
          }
          else {
            this.filteredQBTopics = this.questionBankTopics.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
          }
          if (this.dropMinistry) {
            this.filteredQBService = this.filteredQBService.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
          }
          else {
            this.filteredQBService = this.questionBankService.filter((topics: { questionBankId: any; }) => topics.questionBankId != this.standardQBID);
          }
        }
      }
    } else {
      if (type === 1) {
        this.filteredQBService = this.filteredQBService.filter((item: any) => {
          return item.name.toLowerCase().includes(trimmedSearchText);
        });
      } else {
        this.filteredQBTopics = this.filteredQBTopics.filter((item: any) => {
          return item.name.toLowerCase().includes(trimmedSearchText);
        });
      }
    }
  }

}
